<script setup lang="ts">
import type { Ref } from 'vue';
import { ref } from 'vue';
import ScAnalyticsApi from '@aab/sc-analytics-api';

const container: Ref<Element | null> = ref(null);

const props = withDefaults(
  defineProps<{
    readonly withOffset?: boolean;
    readonly name?: string;
  }>(),
  { withOffset: false, name: '' }
);

function sendAnalytics(event: Event): void {
  event.stopPropagation();
  if (event.target !== container.value) return;
  ScAnalyticsApi.eventTrack({
    eventName: 'click-itext',
    eventCategory: 'i-text',
    eventAction: `irt: i-text shown: ${props.name}`
  });
}
</script>

<template>
  <aab-info-popover ref="container" class="itext" @click="sendAnalytics">
    <div class="text-wrap">
      <div class="i-text-message" role="tooltip" :class="{ '-offset': withOffset }">
        <div class="i-text-message-inner">
          <slot />
        </div>
      </div>
    </div>
  </aab-info-popover>
</template>

<style lang="scss" scoped>
@use '@aab/sc-styles-colors/dist/scss/styles' as colors;

.i-text-message {
  background: colors.$white;
  padding: 16px 0;

  @media (max-width: 300px) {
    max-width: 230px;
  }

  @media (min-width: 301px) and (max-width: 339px) {
    max-width: 280px;
  }

  @media (min-width: 340px) and (max-width: 400px) {
    max-width: 315px;
  }

  @media (min-width: 401px) and (max-width: 474px) {
    max-width: 380px;
  }

  @media (min-width: 475px) and (max-width: 600px) {
    max-width: 450px;
  }

  @media (min-width: 601px) {
    max-width: 480px;
  }

  &.-offset {
    @media (max-width: 400px) {
      max-width: 315px;
    }

    @media (max-width: 365px) {
      max-width: 270px;
    }

    @media (max-width: 345px) {
      max-width: 250px;
    }

    @media (max-width: 320px) {
      max-width: 230px;
    }

    @media (max-width: 300px) {
      max-width: 200px;
    }

    @media (max-width: 280px) {
      max-width: 180px;
    }

    @media (max-width: 255px) {
      max-width: 160px;
    }
  }
}

.i-text-message-inner {
  @media (max-width: 425px) {
    font-size: 14px;
  }

  @media (min-width: 426px) {
    font-size: 15px;
  }
}
</style>
